/**
 * activity-link — path/ลิงก์ของหน้ากิจกรรม **แหล่งเดียวของทั้งระบบ**
 *
 * 🔴 **ทำไมต้องอยู่ใน lib ไม่ใช่ hardcode ที่ route table ของแอป**
 *    ลิงก์นี้ถูก **แชร์ออกไปนอกระบบ** (ในแชท LINE ของผู้ใช้) ⇒ เปลี่ยน path เมื่อไร
 *    ลิงก์ที่ส่งไปแล้วตายทั้งหมด **โดยไม่มีอะไรฟ้อง** — เป็นบทเรียนตัวเดียวกับ
 *    `VERIFY_EMAIL_PATH` ของ `feature-auth` (ลิงก์ในอีเมลที่ส่งไปแล้ว)
 *    ⇒ route table · ปุ่มแชร์ · ปุ่มคัดลอกลิงก์ ต้องอ่านจากที่นี่ที่เดียวเสมอ
 */

/** หน้ารายการ — ตรงกับ path ที่ route table ของแอปประกาศ */
export const ACTIVITIES_PATH = '/activities';

/** pattern ของ route detail (รูปของ React Router) — แอปเอาไปประกาศ route */
export const ACTIVITY_DETAIL_PATH = '/activities/:activityId';

/** path ของกิจกรรมหนึ่ง ๆ (เติม id จริงแล้ว) */
export function activityPath(activityId: string): string {
  /**
   * ⚠️ `encodeURIComponent` ไม่ใช่ของประดับ — id มาจากข้อมูลจริง และวันที่ใครสร้าง id
   *    ที่มี `/` หรือ `?` ปนมา ลิงก์จะพาไปหน้าอื่นเงียบ ๆ แทนที่จะ 404
   */
  return `${ACTIVITIES_PATH}/${encodeURIComponent(activityId)}`;
}

/**
 * ลิงก์เต็มสำหรับ **แชร์ให้คนนอก** — ต้องเป็น absolute URL เพราะปลายทางคือแชท LINE
 * `origin` ถูกส่งเข้ามา ไม่ใช่อ่าน `window.location` เอง (lib ห้ามแตะ global — เทสไม่ได้)
 */
export function activityInviteLink(origin: string, activityId: string): string {
  /**
   * ⚠️ **ไม่ใช้ regex ตัด `/` ท้าย** — `/\/+$/` โดน `sonarjs/slow-regex` (quantifier
   *    ที่ผูกกับ `$` เปิดช่อง backtracking แบบ super-linear) · ลูปนี้เป็น linear
   *    และอ่านง่ายกว่าอยู่ดี
   */
  let base = origin;
  while (base.endsWith('/')) base = base.slice(0, -1);

  return `${base}${activityPath(activityId)}`;
}
